<div class="new-message-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <div class="header-content">
          <h1>Vorlagen</h1>
          <button matButton="outlined" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
            Aktualisieren
          </button>
          <button
            matButton="filled"
            (click)="navigateToNewTemplate()">
            <mat-icon>add</mat-icon>
            Neue Vorlage
          </button>
        </div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      @if (loading()) {
        <div class="loading-container">
          <mat-spinner></mat-spinner>
          <p>Laden...</p>
        </div>
      }

      @if (error()) {
        <div class="error-container">
          <mat-icon color="warn">error</mat-icon>
          <p>Fehler: {{ error()?.message }}</p>
          <button mat-raised-button color="accent" (click)="refresh()">
            Neu laden
          </button>
        </div>
      }

      @if (templates() && !loading()) {
        <div class="table-container">
          <table mat-table [dataSource]="templates()!.content" class="templates-table">

<!--            &lt;!&ndash; ID Column &ndash;&gt;-->
<!--            <ng-container matColumnDef="id">-->
<!--              <th mat-header-cell *matHeaderCellDef>ID</th>-->
<!--              <td mat-cell *matCellDef="let template">{{ template.id }}</td>-->
<!--            </ng-container>-->

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let template">{{ template.name }}</td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Details</th>
              <td mat-cell *matCellDef="let template">{{ template.description || 'N/A' }}</td>
            </ng-container>

            <!-- Created At Column -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef>Erstellt</th>
              <td mat-cell *matCellDef="let template">
                {{ template.created_at | date:'dd.MM.yyyy HH:mm' }} - {{ template.creator }}
              </td>
            </ng-container>

            <!-- Modified At Column -->
            <ng-container matColumnDef="updatedAt">
              <th mat-header-cell *matHeaderCellDef>Aktualisiert</th>
              <td mat-cell *matCellDef="let template">
                {{ template.updated_at | date:'dd.MM.yyyy HH:mm' }} - {{ template.editor }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Aktionen</th>
              <td mat-cell *matCellDef="let template">
<!--                <button mat-icon-button color="primary" (click)="viewTemplate(template.id)" matTooltip="Pregled">-->
<!--                  <mat-icon fontSet="material-symbols-outlined">visibility</mat-icon>-->
<!--                </button>-->
                <button mat-icon-button color="accent" (click)="editTemplate(template.id)" matTooltip="Aktualisieren">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteTemplate(template.id)" matTooltip="Löschen">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- No data row -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                keine Daten!
              </td>
            </tr>
          </table>

          <mat-paginator
            [length]="templates()!.totalElements"
            [pageSize]="templates()!.size"
            [pageIndex]="templates()!.number"
            [pageSizeOptions]="[5, 10, 25, 50]"
            (page)="onPageChange($event)"
            showFirstLastButtons>
          </mat-paginator>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
